import React from "react";
import { Box } from "@mui/material";

interface IProps {
  title: string;
}

const InfoTitle = ({ title }: IProps): React.ReactElement => (
  <Box
    display="flex"
    alignItems="flex-start"
    fontSize="12px"
    fontWeight="normal"
    lineHeight={1.33}
    color="#86868b"
    marginTop="10px !important"
  >
    <Box display="flex" alignItems="center" minHeight="18px">
      {title}
    </Box>
  </Box>
);

export default InfoTitle;
